import React, { useState } from 'react'
import { uid } from '@zera-admin/utils'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import Button from '@zera-admin/button'
import Page, { PageHeader, Container } from '@zera-admin/page'

import { useFlagcardContext } from 'app/contexts/flagcard'
import { ValidationError } from 'app/shared/types'
import MainLayout from 'layouts/main'
import profileReport from 'services/http/report/profile-report'

import { CreatePersonReportProps } from './types'
import { initialValues } from './constant'
import ProfileReportRequestForm from './ProfileReportRequestForm'
import { CreateProfileReportRequest } from 'services/http/report/person-report/types'

const CreatePersonReport: React.FunctionComponent<CreatePersonReportProps> =
  () => {
    const [isLoading, setIsLoading] = useState(false)
    const [flagcard] = useFlagcardContext()

    const handleSubmit = (
      values: CreateProfileReportRequest,
      handleReset: () => void
    ) => {
      if (values) {
        setIsLoading(true)
        profileReport
          .create(values)
          .then(() => {
            flagcard.add({
              id: uid(),
              appearance: 'success',
              title: 'Kayıt işlemi başarılı',
              children:
                'Girmiş olduğunuz bilgiler ile birlikte veri sisteme başarıyla kayıt edilmiştir. Dilerseniz yeni veri ekleyebilirsiniz.',
            })

            handleReset()
          })
          .catch((error) => {
            console.log(error)

            flagcard.add({
              id: uid(),
              appearance: 'error',
              title: 'Bir hata oluştu',
              children:
                'Veri eklenirken bir hata oluştu. Lütfen tekrar deneyin. Sorununuz düzelmediyse servis sağlayıcısı ile iletişime geçiniz.',
            })
          })
          .finally(() => {
            setIsLoading(false)
          })
      }
    }

    const handleError = (error?: ValidationError) => {
      console.log(error)
    }

    const breadcrumbs = (
      <Breadcrumb>
        <BreadcrumbItem text="Anasayfa" href="/" />
        <BreadcrumbItem text="Profil raporu" href="/person-report" />
        <BreadcrumbItem text="Profil raporu oluştur" />
      </Breadcrumb>
    )

    return (
      <MainLayout>
        <Container width="medium">
          <Page>
            <PageHeader
              breadcrumbs={breadcrumbs}
              bottomBar={
                <p>
                  Aşağıdaki bilgileri doldurarak yeni bir Profil raporu
                  oluşturabilirsiniz..
                </p>
              }
            >
              Profil raporu oluştur
            </PageHeader>
            <ProfileReportRequestForm
              actions={
                <Button
                  appearance="primary"
                  children="Profil raporu oluştur"
                  isLoading={isLoading}
                  type="submit"
                />
              }
              operation="create"
              onError={handleError}
              onSubmit={handleSubmit}
              values={initialValues}
            />
          </Page>
        </Container>
      </MainLayout>
    )
  }

export default CreatePersonReport
